interface HandleStatusCodesProps {
  status: number
  acceptNotFound?: boolean
}

export const handleStatusCodes = ({ status, acceptNotFound }: HandleStatusCodesProps): boolean => {
  if (status >= 200 && status < 300) {
    return true
  }

  if (acceptNotFound && status === 404) {
    return false
  }

  return false
}
